// @flow
import styled from "styled-components";
import Button from "../../_atom/Buttons/button";

export const DefaultContainer = styled.div`
  & > * {
    margin-bottom: 12px;
  }
`;

export const BottomSpacer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const BottomResetButton = styled(Button)`
  svg {
    margin-right: 8px;
  }
`;
